import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import AjudaCampo from '../AjudaCampo';
import { LIMITE_DIAS_UTEIS, diaBrt, diasUteis, hojeBrt, quandoBrt } from './cobrancaCanal';

// Cobrança dos canais (Adnéia, 04/11/2026): uma linha só, antes das Anotações, no card de canal
// parceiro ("diminui para ficar tudo em uma linha só", 04/11 16h5x). A data, o Caio ou a Gabi
// leem no portal do canal; o ELO conta os dias úteis até a abertura do atendimento e só avisa
// acima de 5, em vermelho ("6 dias úteis"; a frase inteira aparece ao parar o mouse em cima).
// A marca grava quem e quando ao salvar: a linha mostra "por <primeiro nome>", e o dia e a
// hora aparecem ao parar o mouse em cima. Cada campo tem o "?" com o texto que ela aprovou
// (04/11 17h1x).
const CAMPO_DATA = 'h-7 w-[104px] px-1.5 text-xs md:text-xs';

export const AJUDA = {
  dataCliente: 'Leia no portal ou no e-mail do canal o dia em que o cliente reclamou com o canal e digite '
    + 'aqui. O ELO conta os dias úteis até a abertura deste atendimento: acima de 5, o canal demorou e '
    + 'entra na cobrança. Não achou o dia? Deixe em branco e avise a Adneia.',
  reenvio: 'Marque quando o canal não mandou a etiqueta da transportadora e vamos seguir com o reenvio '
    + 'mesmo assim. O ELO grava quem marcou e quando. Marcou sem querer? Desmarque.',
  etiqueta: 'Se a etiqueta chegar depois do reenvio, digite o dia. A marca fica, porque o reenvio já saiu sem ela.',
};

export default function LinhaCobrancaCanal({
  dataCliente, onDataCliente, reenvio, onReenvio, etiquetaEm, onEtiquetaEm,
  marcadoPor, marcadoEm, abertura, feriados,
}) {
  const hoje = hojeBrt();
  const dias = feriados && dataCliente
    ? diasUteis(dataCliente, diaBrt(abertura) || hoje, feriados)
    : null;
  const quando = quandoBrt(marcadoEm);

  return (
    <Card data-testid="linha-cobranca-canal">
      <CardContent className="px-3 py-2">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1.5 text-xs whitespace-nowrap">
          <label className="flex items-center gap-1">
            <span className="font-medium">Cliente acionou o canal em</span>
            <AjudaCampo titulo="Cliente acionou o canal em" testid="ajuda-data-cliente-canal">{AJUDA.dataCliente}</AjudaCampo>
            <Input type="date" className={`ml-0.5 ${CAMPO_DATA}`} max={hoje} value={dataCliente || ''}
              onChange={(e) => onDataCliente(e.target.value)} data-testid="input-data-cliente-canal" />
          </label>
          {dias !== null && dias > LIMITE_DIAS_UTEIS && (
            <span className="font-medium text-red-600 dark:text-red-400" data-testid="aviso-canal-demorou"
              title={`Canal levou ${dias} dias úteis para nos acionar; o limite é ${LIMITE_DIAS_UTEIS}`}>
              {dias} dias úteis
            </span>
          )}
          <label className="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" className="h-3.5 w-3.5 accent-primary" checked={!!reenvio}
              onChange={(e) => onReenvio(e.target.checked)} data-testid="checkbox-reenvio-sem-etiqueta" />
            <span className="font-medium">Reenvio sem a etiqueta</span>
            <AjudaCampo titulo="Reenvio sem a etiqueta" testid="ajuda-reenvio-sem-etiqueta">{AJUDA.reenvio}</AjudaCampo>
          </label>
          {reenvio && marcadoPor && (
            <span className="text-[11px] text-muted-foreground" title={`Marcado por ${marcadoPor}, ${quando}`}
              data-testid="reenvio-quem-quando">
              por {marcadoPor.split(' ')[0]}
            </span>
          )}
          {reenvio && (
            <label className="flex items-center gap-1">
              <span className="text-muted-foreground">Etiqueta chegou em</span>
              <AjudaCampo titulo="Etiqueta chegou em" testid="ajuda-etiqueta-chegou">{AJUDA.etiqueta}</AjudaCampo>
              <Input type="date" className={`ml-0.5 ${CAMPO_DATA}`} max={hoje} value={etiquetaEm || ''}
                onChange={(e) => onEtiquetaEm(e.target.value)} data-testid="input-etiqueta-chegou" />
            </label>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
